_.mixin(module.exports = {
  deepClone: function(object) {
    var clone;
    clone = _.clone(object);
    _.each(clone, function(value, key) {
      if (_.isObject(value)) {
        return clone[key] = _.deepClone(value);
      }
    });
    return clone;
  },
  isBlank: function(obj) {
    if (_.isString(obj)) {
      return !/\S/.test(obj);
    } else {
      return _.isEmpty(obj);
    }
  },
  escapeRegExp: function(str) {
    if (str != null) {
      return String(str).replace(/([-.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    } else {
      return '';
    }
  }
});

